// Browser session for a signed-in insurance member. Used by both the passcode login and
// the SSO landing page so the two always store the same keys.
const SESSION_KEYS = [
  'insuranceLoginEmail',
  'insuranceCompany',
  'insuranceKycRequired',
  'insuranceBeneficiaries',
  'insuranceEmployeeMail',
  'insurancePhoneNumber',
];

export const clearInsuranceSession = (storage = localStorage) => {
  SESSION_KEYS.forEach((key) => storage.removeItem(key));
};

/**
 * @param {string} loginEmail - the email the member signed in with
 * @param {object} member - insurance wallet details returned by the login/SSO API
 */
export const startInsuranceSession = (loginEmail, member = {}) => {
  // Clear the previous member's values first: the optional keys below are only written
  // when present, so without this a stale value from an earlier login could remain.
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));

  localStorage.setItem('insuranceLoginEmail', loginEmail);

  if (member.insurance_company) {
    localStorage.setItem('insuranceCompany', member.insurance_company);
  }

  // Store kyc_required from insurancewallets response; default to true if absent
  localStorage.setItem('insuranceKycRequired', member.kyc_required === false ? 'false' : 'true');

  // Store beneficiary data for use when kyc_required is false
  if (member.beneficiaries) {
    localStorage.setItem('insuranceBeneficiaries', JSON.stringify(member.beneficiaries));
  }
  if (member.employee_mail) {
    localStorage.setItem('insuranceEmployeeMail', member.employee_mail);
  }
  if (member.phone_number) {
    localStorage.setItem('insurancePhoneNumber', member.phone_number);
  }
};
